module.exports = __webpack_public_path__ + "static/img/15baibai.c5749929.gif";